import type { Escola } from "~/types/schemas/escola";
import type { BaseEntity } from "~/types/schemas";
import type { APIOptions } from "@sieg-ad/fetch";
import { API } from "~/composables/api";

class EscolaAPI <T extends BaseEntity = Escola> {
  find = async (options?: APIOptions) => {
    return await API.get<T>(`/escolas`, options);
  }

  findOne = async (escola_id: number | string, options?: APIOptions) => {
    return await API.getOne<T>(`/escolas/${escola_id}`, options);
  }

  create = async (payload: T) => {
    return await API.post<T>(`/escolas`, { body: payload });
  }

  update = async (escola_id: number | string, payload: Partial<T>) => {
    return await API.put<T>(`/escolas/${escola_id}`, { body: payload });
  }
}

export const EscolaApi = new EscolaAPI();